<ng-container *ngIf="subjects.length > 0">
  <span class="sr-only">{{ 'item.page.subject' | translate }}: </span>
  <a *ngFor="let subject of subjects"
     class="badge subject-badge mr-1"
     [routerLink]="['/search']"
     [queryParams]="getQueryParams(subject)">{{ subject }}</a>
</ng-container>
